/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const Invoice = {

	delete (context, invoiceId, onSuccess, onError, options) {
		Api.delete(context,
			"/invoice"
			+ "?invoiceId=" + invoiceId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	get (context, invoiceId, onSuccess, onError, options) {
		Api.get(context,
			"/invoice"
			+ "?invoiceId=" + invoiceId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getGeneralInfo (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/invoice/general-info"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getInvoicesDonationSum (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/invoice/invoices-donation-sum"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getIsNumberTaken (context, projectId, documentNumber, invoiceId, onSuccess, onError, options) {
		Api.get(context,
			"/invoice/is-number-taken"
			+ "?projectId=" + projectId
			+ "&documentNumber=" + documentNumber
			+ "&invoiceId=" + invoiceId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getIsReferenced (context, projectId, actionId, costSerialNumber, onSuccess, onError, options) {
		Api.get(context,
			"/invoice/is-referenced"
			+ "?projectId=" + projectId
			+ "&actionId=" + actionId
			+ "&costSerialNumber=" + costSerialNumber
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getPossibleReferences (context, projectId, invoiceId, actionId, onSuccess, onError, options) {
		Api.get(context,
			"/invoice/possible-references"
			+ "?projectId=" + projectId
			+ "&invoiceId=" + invoiceId
			+ "&actionId=" + actionId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	post (context, projectId, invoiceDTO, onSuccess, onError, options) {
		Api.post(context,
			"/invoice"
			+ "?projectId=" + projectId
			, invoiceDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	put (context, invoiceDTO, onSuccess, onError, options) {
		Api.put(context,
			"/invoice"
			, invoiceDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
